import { render, staticRenderFns } from "./CourseQuiz.vue?vue&type=template&id=e31122d0"
import script from "./CourseQuiz.vue?vue&type=script&lang=js"
export * from "./CourseQuiz.vue?vue&type=script&lang=js"
import style0 from "./CourseQuiz.vue?vue&type=style&index=0&id=e31122d0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports